import { O2AccordionGroupComponent } from './lib/o2-accordion-group.component';
import { O2AccordionItemComponent } from './lib/o2-accordion-item.component';

export * from './lib/o2-accordion-group.component';
export * from './lib/o2-accordion-item.component';

/**
 * O2 Accordion Imports
 *
 * Import this array to use the O2 Accordion components.
 * Includes both Group and Item components.
 *
 * Usage:
 * @Component({
 *   imports: [O2AccordionImports, ...]
 * })
 */
export const O2AccordionImports = [O2AccordionGroupComponent, O2AccordionItemComponent] as const;
